import { render, staticRenderFns } from "./RankingsPopup.vue?vue&type=template&id=00b11270"
import script from "./RankingsPopup.vue?vue&type=script&lang=js"
export * from "./RankingsPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports